import { StatsEmitter } from './emitter';
import { EventEmitterFactory } from '../event/emitter.factory';
import { StatsContexterService } from '../../service/stats-contexter/service';
import { StatsEmitterEntityStrategyFactory } from './emitter/entity-strategy.factory';
import { StatsDebuggerService } from '../../service/stats-debugger/service';

export function StatsEmitterFactory(): StatsEmitter {
  return new StatsEmitter(
    EventEmitterFactory(),
    StatsContexterService(),
    StatsEmitterEntityStrategyFactory(),
    StatsDebuggerService()
  );
}
